// 문의 관리(시안 v6 API) 화면용 순수 함수. 코드값은 GET /inquiries/meta 가 정본이다.
export const EMPTY_FILTER = { channel: "all", statuses: null, category: "", assignee: "", from: "", to: "", q: "" };
export const STATUS_CLS = { new: "new", processing: "ing", on_hold: "hold", completed: "done", canceled: "cancel" };
// 사유(reason, 200자 · 가맹점주에게 보인다)를 받는 상태 — 계약 §4-4
export const REASON_STATUSES = ["on_hold", "canceled"];
export const needsReason = (code) => REASON_STATUSES.includes(code);

export const openStatuses = (meta) => (meta?.statuses || []).filter((s) => s.open).map((s) => s.code);

export function filterToParams(f, meta, { forBoard = false } = {}) {
    const p = new URLSearchParams();
    if (!forBoard) (f.statuses ?? openStatuses(meta)).forEach((s) => p.append("status", s));
    if (f.channel && f.channel !== "all") p.set("channel", f.channel);
    if (f.category) p.set("category_code", f.category);
    if (f.assignee !== "" && f.assignee != null) p.set("assignee", String(f.assignee));
    if (f.from) p.set("created_from", f.from);
    if (f.to) p.set("created_to", f.to);
    if (f.q && f.q.trim()) p.set("q", f.q.trim());
    return p;
}

export const statusLabel = (meta, code) => (meta?.statuses || []).find((s) => s.code === code)?.label || code;

const digits = (s) => String(s || "").replace(/\D/g, "");
export const bizFmt = (b) => {
    const d = digits(b);
    return d.length === 10 ? `${d.slice(0, 3)}-${d.slice(3, 5)}-${d.slice(5)}` : b || "";
};
export function phoneFmt(s) {
    if (!/^\d+$/.test(String(s || ""))) return s || "";
    const d = String(s);
    if (d.startsWith("02") && (d.length === 9 || d.length === 10)) return `02-${d.slice(2, d.length - 4)}-${d.slice(-4)}`;
    if (d.length === 10 || d.length === 11) return `${d.slice(0, 3)}-${d.slice(3, d.length - 4)}-${d.slice(-4)}`;
    return d;
}

const KST = new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Seoul", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23" });
function kstParts(iso) {
    if (!iso) return null;
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return null;
    return Object.fromEntries(KST.formatToParts(d).map((x) => [x.type, x.value]));
}
export const kstShort = (iso) => { const p = kstParts(iso); return p ? `${p.month}-${p.day} ${p.hour}:${p.minute}` : ""; };
export const kstFull = (iso) => { const p = kstParts(iso); return p ? `${p.year}-${p.month}-${p.day} ${p.hour}:${p.minute}` : ""; };

export const registrarLabel = (r) => (r?.type === "staff" ? r.name || "직원" : "챗봇 자동 접수");
export const assigneeNames = (item) => (item.assignees || []).map((a) => a.name).join(", ");

export function groupByTeam(staff, { activeOnly = false } = {}) {
    const out = [];
    (staff || []).filter((s) => !activeOnly || s.active).forEach((s) => {
        const team = s.team || "소속 없음";
        let g = out.find((x) => x.team === team);
        if (!g) { g = { team, members: [] }; out.push(g); }
        g.members.push(s);
    });
    return out;
}

export const cardsFor = (col, cards) =>
    (cards || []).filter((c) => (col.id === null ? (c.assignee_ids || []).length === 0 : (c.assignee_ids || []).includes(col.id)));

export function moveAction(card, from, to) {
    if (from === to) return null;
    const ids = card.assignee_ids || [];
    if (to === null) return from === null ? null : { kind: "remove", from };
    if (ids.includes(to)) return null;
    return from === null ? { kind: "add", to } : { kind: "transfer", from, to };
}
